module.exports = __webpack_public_path__ + "img/body-2-lg.dbcb4c2f.png";